import Api from "../Api";

const errorResponse = (type) => ({
  success: false,
  error: { type, details: [{ message: type }] }
});

const handleError = (error) => {
  try {
    if (error.response.data === "Unauthorized") return errorResponse("UnauthorizedError");
    return error.response.data;
  } catch(e) {
    return errorResponse("NetworkError");
  }
};

export default class SavedArea {
  async create({ data, token }) {
    return Api.post("/saved-area", data, {
      headers: { "Authorization": "bearer " + token }
    }).then(r => r.data).catch(handleError);
  }

  async findAll({ data = {}, token }) {
    return Api.post("/saved-area/find-all", data, {
      headers: { "Authorization": "bearer " + token }
    }).then(r => r.data).catch(handleError);
  }

  // Mesmo contrato dos outros findAutocomplete do site (Tracker, VirtualFence, Patrimony): devolve o array direto, [] em erro
  async findAutocomplete({ data, token }) {
    const response = await this.findAll({ data, token });
    if (response && response.success) return response.data.docs || [];
    return [];
  }

  async update({ id, data, token }) {
    return Api.put(`/saved-area/${id}`, data, {
      headers: { "Authorization": "bearer " + token }
    }).then(r => r.data).catch(handleError);
  }

  async delete({ id, token }) {
    return Api.delete(`/saved-area/${id}`, {
      headers: { "Authorization": "bearer " + token }
    }).then(r => r.data).catch(handleError);
  }
}
